import { isAgentUser, isSeniorAgent } from "./utils";

export const restrictRoute = (nextState, replace, callback) => {

const restrictedPathForIsSeniorAgent = new Set([
  "/upload-file",
   "/users",
   "/buyers",
    "/contacts",
    "/company",
    "/merging",
    "/hsc-pipeline",
    "/geocoder",
     "/firm",
    "/tenant",
    "/lender",
    "/investor",
    "/teamMember",
    "/proposals",
    "/vendor",
    "/userList",
    "/events",
    "/news-list",
    "/news",
    "/rover"
])

  const restrictedPathsForIsAgents = new Set([
    "/list",
    "/training",
    "/upload-file",
    "/users",
    "/stats",
    "/map",
    "/buyer-state-breakdown",
    "/transaction-breakdown",
    "/market-transaction-breakdown",
    "/market-share",
    "/buyers",
    "/agent-pipeline",
    "/buckets",
    "/strive-fees",
    "/pipeline",
    "/property-statistics",
    "/inventory",
    "/escrow-tracking",
    "/rover",
    "/contacts",
    "/company",
    "/merging",
    "/agent-commission-breakdown",
    "/hsc-pipeline",
    "/hsc-tracking",
    "/hsc-stats",
    "/hsc-hotlist",
    "/geocoder",
    "/firm",
    "/tenant",
    "/lender",
    "/agent",
    "/investor",
    "/teamMember",
    "/proposals",
    "/vendor",
    "/userList",
    "/events",
    "/news-list",
    "/news",
    "/rover"
    // Add more restricted base paths
  ]);

  const storedUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");

  const path = nextState && nextState.location && nextState.location.pathname
    ? nextState.location.pathname.toLowerCase()
    : "";

  const isUserRestrictedisAgent = isAgentUser(storedUserData);
  const isUserRestrictedIsSeniorAgent = isSeniorAgent(storedUserData)
 const isPathRestrictedForIsAgent = Array.from(restrictedPathsForIsAgents).some((restrictedPath) =>
  path.startsWith(restrictedPath.toLowerCase())
);
 const isPathRestrictedIsSeniorAgent = Array.from(restrictedPathForIsSeniorAgent).some((restrictedPath) =>
  path.startsWith(restrictedPath.toLowerCase())
);
if (
  (isUserRestrictedisAgent && isPathRestrictedForIsAgent) ||
  (isUserRestrictedIsSeniorAgent && isPathRestrictedIsSeniorAgent)
) {
  replace("/unauthorized");
}

  callback();
};
